import { DateTime } from 'luxon'
/**
* @author Edgar Escobedo
* @description return date in format DD de MMM del YYYY ej: 28 de junio del 2023
* @updatedDate 04-07-2023
* @param {Number} date 
* @returns {date}
*/

import moment from "moment"

const dateDayMonthCompleteAndYearComplete = (date) => {
  let split = date.split('/')
  let day = (split && split.length > 0) ? split[0] : ''
  let month = (split && split.length > 0) ? split[1] : ''
  let year = (split && split.length > 0) ? split[2] : ''

  let monthString = ''
  let yearString = `${year}`

  if (month === '01') {
    monthString = 'enero'
  } else if (month === '02') {
    monthString = 'febrero'
  } else if (month === '03') {
    monthString = 'marzo'
  } else if (month === '04') {
    monthString = 'abril'
  } else if (month === '05') {
    monthString = 'mayo'
  } else if (month === '06') {
    monthString = 'junio'
  } else if (month === '07') {
    monthString = 'julio'
  } else if (month === '08') {
    monthString = 'agosto'
  } else if (month === '09') {
    monthString = 'septiembre'
  } else if (month === '10') {
    monthString = 'octubre'
  } else if (month === '11') {
    monthString = 'noviembre'
  } else if (month === '12') {
    monthString = 'diciembre'
  }
  let dateResult = `${day} de ${monthString} del ${yearString}`
  return dateResult
}


/**
* @author Edgar Escobedo
* @description return date in format DD/MMM/YYYY ej: 28/Agosto/2023 
* @updatedDate 05-07-2023
* @param {Number} date 
* @returns {date}
*/
const limitExpirationDateInContract = (date) => {
  moment.locale("es");
  let yearStartContractL = date.split("/")[2];
  let monthStartContractL = date.split("/")[1];
  let dayStartContractL = date.split("/")[0];
  let dateLimit = dayStartContractL +
    "/" +
    moment(monthStartContractL).format("MMM").toLowerCase() +
    "/" +
    yearStartContractL
  dateLimit = dateLimit.replaceAll(".", "")
  return dateLimit
}


/**
* @author Edgar Escobedo
* @description return date in format DD/MMM/YYYY ej: 28/Agosto/2023 
* @updatedDate 05-07-2023
* @param {Number} date 
* @returns {date}
*/
const dateInDialogChanceDate = (date) => {
  moment.locale("es");
  let [day, month, year] = date.split("/");
  let dateConvert = new Date(+year, +month - 1, +day) > new Date()
    ? new Date(+year, +month - 1, +day)
    : new Date()
  return dateConvert
}

/**
* @author Edgar Escobedo
* @description convert a date from BD to Show in date
* @updatedDate 09-11-2023
* @param {Number} date 
* @returns {date}
*/

const convertDateBDToShow = (date) => {
  let dateParse = new Date(date.replace(/-/g, '/')).toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric" })
  let day = (dateParse) ? dateParse.split('/')[1] : ''
  let month = (dateParse) ? dateParse.split('/')[0] : ''
  let year = (dateParse) ? dateParse.split('/')[2] : ''
  let completeDate = year + '/' + month + '/' + day
  let dateConvert = new Date(completeDate)

  return dateConvert

}

/**
* @author Edgar Escobedo
* @description convert some string dates in dates
* @updatedDate 09-11-2023
* @param {Number} date 
* @returns {date}
*/
const convertStringInDates = (date) => {
  let dateComplete
  let dateReplace
  let dateSplit0
  let dateSplit1
  let dateSplit2
  let format

  if (date.includes('-')) {
    dateReplace = date.replace(/-/g, '/')
    dateSplit0 = dateReplace.split('/')[0]
    dateSplit1 = dateReplace.split('/')[1]
    dateSplit2 = dateReplace.split('/')[2]

    let monthNumber = (dateSplit1) ? Number(dateSplit1) : null
    if (dateSplit0.length === 4 && monthNumber && Number.isInteger(monthNumber)) {
      dateComplete = `${dateSplit0}/${dateSplit1}/${dateSplit2}`
      format = 'yyyy-MM-dd'
    }

    if (dateSplit0.length === 2 && monthNumber && Number.isInteger(monthNumber)) {
      dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`
      format = 'dd-MM-yyyy'
    }
  }

  if (date.includes('/')) {
    dateSplit0 = date.split('/')[0]
    dateSplit1 = date.split('/')[1]
    dateSplit2 = date.split('/')[2]
    if (dateSplit0.length === 4) {
      dateComplete = `${dateSplit0}/${dateSplit1}/${dateSplit2}`
      format = 'yyyy/MM/dd'
    }

    if (dateSplit0.length === 2) {
      dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`
      format = 'dd/MM/yyyy'
    }
  }

  if (dateSplit1 && dateSplit1.length === 3) {
    if (dateSplit1 === 'Ene' || dateSplit1 === 'ene' || dateSplit1 === 'Enero' || dateSplit1 === 'enero') {
      dateSplit1 = '01'
    } else if (dateSplit1 === 'Feb' || dateSplit1 === 'feb' || dateSplit1 === 'Febrero' || dateSplit1 === 'febrero') {
      dateSplit1 = '02'
    } else if (dateSplit1 === 'Mar' || dateSplit1 === 'mar' || dateSplit1 === 'Marzo' || dateSplit1 === 'marzo') {
      dateSplit1 = '03'
    } else if (dateSplit1 === 'Abr' || dateSplit1 === 'abr' || dateSplit1 === 'Abril' || dateSplit1 === 'abril') {
      dateSplit1 = '04'
    } else if (dateSplit1 === 'May' || dateSplit1 === 'may' || dateSplit1 === 'Mayo' || dateSplit1 === 'mmayo') {
      dateSplit1 = '05'
    } else if (dateSplit1 === 'Jun' || dateSplit1 === 'jun' || dateSplit1 === 'Junio' || dateSplit1 === 'junio') {
      dateSplit1 = '06'
    } else if (dateSplit1 === 'Jul' || dateSplit1 === 'jul' || dateSplit1 === 'Julio' || dateSplit1 === 'julio') {
      dateSplit1 = '07'
    } else if (dateSplit1 === 'Ago' || dateSplit1 === 'ago' || dateSplit1 === 'Agosto' || dateSplit1 === 'agosto') {
      dateSplit1 = '08'
    } else if (dateSplit1 === 'Sep' || dateSplit1 === 'sep' || dateSplit1 === 'Septiembre' || dateSplit1 === 'septiembre') {
      dateSplit1 = '09'
    } else if (dateSplit1 === 'Oct' || dateSplit1 === 'oct' || dateSplit1 === 'Octubre' || dateSplit1 === 'octubre') {
      dateSplit1 = '10'
    } else if (dateSplit1 === 'Nov' || dateSplit1 === 'nov' || dateSplit1 === 'Noviembre' || dateSplit1 === 'noviembre') {
      dateSplit1 = '11'
    } else if (dateSplit1 === 'Dic' || dateSplit1 === 'dic' || dateSplit1 === 'Diciembre' || dateSplit1 === 'diciembre') {
      dateSplit1 = '12'
    }

    if (dateSplit0.length === 2) {
      dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`
    }

    if (dateSplit0.length === 4) {
      dateComplete = `${dateSplit0}/${dateSplit1}/${dateSplit2}`
    }

  }

  if (date.includes('de') || date.includes('del')) {
    let splitDate = date.split(' ')
    dateSplit0 = splitDate[0]
    dateSplit1 = splitDate[2]
    dateSplit2 = splitDate[4]
    if (!Number(dateSplit2)) {
      let year = splitDate.find(split => split.length === 4)
      dateSplit2 = (year) ? year : dateSplit2
    }
    if (dateSplit1 === 'Ene' || dateSplit1 === 'ene' || dateSplit1 === 'Enero' || dateSplit1 === 'enero') {
      dateSplit1 = '01'
    } else if (dateSplit1 === 'Feb' || dateSplit1 === 'feb' || dateSplit1 === 'Febrero' || dateSplit1 === 'febrero') {
      dateSplit1 = '02'
    } else if (dateSplit1 === 'Mar' || dateSplit1 === 'mar' || dateSplit1 === 'Marzo' || dateSplit1 === 'marzo') {
      dateSplit1 = '03'
    } else if (dateSplit1 === 'Abr' || dateSplit1 === 'abr' || dateSplit1 === 'Abril' || dateSplit1 === 'abril') {
      dateSplit1 = '04'
    } else if (dateSplit1 === 'May' || dateSplit1 === 'may' || dateSplit1 === 'Mayo' || dateSplit1 === 'mmayo') {
      dateSplit1 = '05'
    } else if (dateSplit1 === 'Jun' || dateSplit1 === 'jun' || dateSplit1 === 'Junio' || dateSplit1 === 'junio') {
      dateSplit1 = '06'
    } else if (dateSplit1 === 'Jul' || dateSplit1 === 'jul' || dateSplit1 === 'Julio' || dateSplit1 === 'julio') {
      dateSplit1 = '07'
    } else if (dateSplit1 === 'Ago' || dateSplit1 === 'ago' || dateSplit1 === 'Agosto' || dateSplit1 === 'agosto') {
      dateSplit1 = '08'
    } else if (dateSplit1 === 'Sep' || dateSplit1 === 'sep' || dateSplit1 === 'Septiembre' || dateSplit1 === 'septiembre') {
      dateSplit1 = '09'
    } else if (dateSplit1 === 'Oct' || dateSplit1 === 'oct' || dateSplit1 === 'Octubre' || dateSplit1 === 'octubre') {
      dateSplit1 = '10'
    } else if (dateSplit1 === 'Nov' || dateSplit1 === 'nov' || dateSplit1 === 'Noviembre' || dateSplit1 === 'noviembre') {
      dateSplit1 = '11'
    } else if (dateSplit1 === 'Dic' || dateSplit1 === 'dic' || dateSplit1 === 'Diciembre' || dateSplit1 === 'diciembre') {
      dateSplit1 = '12'
    }
    dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`

    format = {
      day: 'numeric',
      month: "short",
      year: "numeric"
    }
  }

  if (!dateComplete || !dateSplit0 || isNaN(!dateSplit0) || !dateSplit1 || isNaN(!dateSplit1) || !dateSplit2 || isNaN(!dateSplit2)) return null
  let dateConvert = new Date(dateComplete)
  if (isNaN(dateConvert)) return null

  let data = {
    date: dateConvert,
    format
  }

  return data
}

/**
 * @author Edgar Escobedo
 * @description Convert a date to standar date.
 * @updatedDate 21/11/2024
 * @typedef {Object} Props
 * @property {String} date Se convierte la fecha a string y se envia con el formato requerido
 * ```js
 * let date = 2023-10-25
 * @property {String} language Es el lenguaje que tiene el sitema para convrtir correctamente la fecha
 *  * ```js
 * let language = 'es'
 * @return {JSX.Element} 
 */
const convertToStandarDate = (date, language) => {
  if (!date) return ''

  moment.locale(language || 'es')
  const isString = typeof date === 'string'
  const hasTimeOrTZ = isString && (/[Tt]/.test(date) || /Z$/.test(date) || /[-+]\d{2}:?\d{2}$/.test(date))
  const m = hasTimeOrTZ ? moment.utc(date) : moment(date)
  const convertDate = m.format('DD/MMM/YYYY')
  const dateStandar = convertDate.replaceAll('.', '').toLowerCase()
  return dateStandar
}

/**
 * @author Marissa Vargas
 * @description - Transforms a formatted string date to a Date object
 * @param {string} dateStr - The date with a DD/MM/YY format. Returned value from `convertToStandardDate` function.
 * @param {'es'|'en'} preferredLangue - String that represents the language of the app. It serves to choose the object to compare the month.
 * @return {Date} - The date as a Date object.
 * @example
 * ```js
 * parseCustomDate({
    dateStr: '19/jun/25',
    preferredLanguage: 'es',
  })
 * ```
 */
const parseCustomDate = ({ dateStr, preferredLanguage }) => {
  if (!dateStr) return new Date(0)

  const parts = dateStr.split('/')
  if (parts.length !== 3) return new Date(0)

  const day = parseInt(parts[0], 10)
  const monthName = parts[1].toLowerCase()
  const rawYear = parts[2]
  const yearNum = parseInt(rawYear, 10)
  const year = rawYear.length <= 2 ? (2000 + (isNaN(yearNum) ? 0 : yearNum)) : yearNum

  const monthEN = {
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11
  }

  const monthES = {
    ene: 0,
    feb: 1,
    mar: 2,
    abr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    ago: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dic: 11
  }

  let monthEnum

  switch (preferredLanguage) {
    case 'es':
      monthEnum = monthES
      break
    case 'en':
      monthEnum = monthEN
      break
    default:
      monthEnum = monthES
      break
  }

  const month = monthEnum[monthName] || 0

  return new Date(year, month, day)
}

/**
 * @author Edgar Escobedo
 * @description Normalize various date formats into a Date object for consistent sorting.
 * @createdDate 02-10-2025
 * @param {string|Date} dateValue - The date value to normalize, which can be a Date object or a string in various formats.
 * @returns {Date} - A Date object representing the normalized date, or a default date (January 1, 1970) if parsing fails.
 * @example
 * ```js
 * normalizeDateForSorting('2024-10-25T10:30:00Z')
 */
const normalizeDateForSorting = (dateValue) => {
  if (!dateValue) return new Date(0)

  if (dateValue instanceof Date && !isNaN(dateValue)) {
    return dateValue
  }

  const dateStr = String(dateValue).trim()

  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    const date = new Date(dateStr)
    return isNaN(date) ? new Date(0) : date
  }

  if (/^\d{1,2}\/\d{1,2}\/\d{2,4}/.test(dateStr)) {
    const [day, month, year] = dateStr.split('/')
    const fullYear = year.length === 2 ? (parseInt(year) > 50 ? '19' + year : '20' + year) : year
    const date = new Date(fullYear, parseInt(month) - 1, parseInt(day))
    return isNaN(date) ? new Date(0) : date
  }

  if (/^\d{1,2}\s+\w{3,}\s+\d{4}/.test(dateStr)) {
    const monthMap = {
      'ene': 0, 'enero': 0, 'jan': 0, 'january': 0,
      'feb': 1, 'febrero': 1, 'february': 1,
      'mar': 2, 'marzo': 2, 'march': 2,
      'abr': 3, 'abril': 3, 'apr': 3, 'april': 3,
      'may': 4, 'mayo': 4,
      'jun': 5, 'junio': 5, 'june': 5,
      'jul': 6, 'julio': 6, 'july': 6,
      'ago': 7, 'agosto': 7, 'aug': 7, 'august': 7,
      'sep': 8, 'septiembre': 8, 'september': 8,
      'oct': 9, 'octubre': 9, 'october': 9,
      'nov': 10, 'noviembre': 10, 'november': 10,
      'dic': 11, 'diciembre': 11, 'dec': 11, 'december': 11
    }

    const parts = dateStr.split(/\s+/)
    if (parts.length >= 3) {
      const day = parseInt(parts[0])
      const monthName = parts[1].toLowerCase()
      const year = parseInt(parts[2])
      const monthIndex = monthMap[monthName]

      if (monthIndex !== undefined) {
        const date = new Date(year, monthIndex, day)
        return isNaN(date) ? new Date(0) : date
      }
    }
  }

  const genericDate = new Date(dateStr)
  return isNaN(genericDate) ? new Date(0) : genericDate
}

/**
 * @author Pedro Antonio
 * @function detectLuxonFormat
 * @description Detecta el formato de una fecha en string y retorna el patrón compatible con `DateTime.fromFormat` de Luxon.
 * Soporta formatos numéricos con `-` o `/`, meses con nombre (corto y largo, ES/EN) y frases como "28 de junio del 2023".
 * Si no es posible determinar el formato, retorna `null`.
 * @param {string} dateStr - La fecha en string (ej: '2025-12-1', '01/02/2025', '28/jun/25', '28 de junio del 2023').
 * @returns {string|null} - El patrón de formato para Luxon (ej: 'yyyy-M-d'), o `null` si no se puede detectar.
 * @example
 * // Devuelve 'yyyy-M-d'
 * detectLuxonFormat('2025-12-1')
 * @example
 * // Devuelve "d 'de' LLLL 'del' yyyy"
 * detectLuxonFormat('28 de junio del 2023')
 */
const detectLuxonFormat = (dateStr) => {
  if (typeof dateStr !== 'string') return null
  const raw = dateStr.trim()
  if (!raw) return null

  // Helper: token por longitud y tipo
  const yearToken = (s) => (s && s.length === 2 ? 'yy' : 'yyyy')
  const mdToken = (s, kind) => {
    const two = s && s.length === 2
    if (kind === 'M') return two ? 'MM' : 'M'
    return two ? 'dd' : 'd'
  }

  // 1) Frases con "de"/"del" y mes con letras (ES/EN)
  const hasLetters = /[A-Za-zÁÉÍÓÚáéíóúñ]/.test(raw)
  if (hasLetters) {
    // "28 de junio del 2023" -> d 'de' LLLL 'del' yyyy
    if (/\bde\b|\bdel\b/i.test(raw)) {
      // Determinar si el mes parece largo o corto
      const monthWordMatch = raw.match(/\b([A-Za-zÁÉÍÓÚáéíóúñ]{3,})\b/)
      const monthWord = monthWordMatch ? monthWordMatch[1] : ''
      const isLong = monthWord.length > 3
      const monthToken = isLong ? 'LLLL' : 'LLL'

      // Detectar orden típico: d 'de' LLLL 'del' yyyy
      // Permitimos que falte 'del' (algunas frases usan solo 'de')
      const hasDel = /\bdel\b/i.test(raw)
      if (hasDel) return `d 'de' ${monthToken} 'del' yyyy`
      return `d 'de' ${monthToken} 'de' yyyy`
    }

    // Formatos con separadores y mes abreviado/largo: 28/jun/25 o 28/Junio/2023
    const sep = raw.includes('/') ? '/' : (raw.includes('-') ? '-' : null)
    if (sep) {
      const [p1, p2, p3] = raw.split(sep)
      if (p1 && p2 && p3) {
        const monthToken = p2.length > 3 ? 'LLLL' : 'LLL'
        // Heurística de año 2 o 4 dígitos
        const yTok = yearToken(p3)
        // Asumimos d/LLL(/LLLL)/yy(yyyy)
        return `d${sep}${monthToken}${sep}${yTok}`
      }
    }

    // Mes con nombre sin separadores formales: "28 jun 2025"
    const parts = raw.split(/\s+/)
    if (parts.length === 3 && /\d{1,2}/.test(parts[0]) && /\d{2,4}/.test(parts[2])) {
      const monthToken = parts[1].length > 3 ? 'LLLL' : 'LLL'
      const yTok = yearToken(parts[2])
      return `d ${monthToken} ${yTok}`
    }
  }

  // 2) Numéricos con separador '-'
  if (raw.includes('-')) {
    const [a, b, c] = raw.split('-')
    if (a && b && c && /^\d+$/.test(a + b + c)) {
      const na = parseInt(a, 10)
      const nb = parseInt(b, 10)
      const nc = parseInt(c, 10)

      const aIsYear = a.length === 4 || na > 31
      const bIsYear = b.length === 4 || nb > 31
      const cIsYear = c.length === 4 || nc > 31

      // yyyy-?-? (ISO-like)
      if (aIsYear) {
        const mTok = mdToken(b, 'M')
        const dTok = mdToken(c, 'd')
        return `${yearToken(a)}-${mTok}-${dTok}`
      }

      // ?-yyyy-? (raro)
      if (bIsYear) {
        const firstIsMonth = na <= 12
        const firstTok = mdToken(a, firstIsMonth ? 'M' : 'd')
        const lastTok = mdToken(c, firstIsMonth ? 'd' : 'M')
        return `${firstTok}-${yearToken(b)}-${lastTok}`
      }

      // ?-?-yyyy (común latam)
      if (cIsYear) {
        // decidir entre d-M-yyyy o M-d-yyyy
        let firstIsDay
        if (na > 12) firstIsDay = true
        else if (nb > 12) firstIsDay = false
        else firstIsDay = true // por convención dd-MM-yyyy

        const firstTok = mdToken(a, firstIsDay ? 'd' : 'M')
        const secondTok = mdToken(b, firstIsDay ? 'M' : 'd')
        return `${firstTok}-${secondTok}-${yearToken(c)}`
      }

      // Ambiguo: asumir yyyy-M-d si a tiene pinta de año corto (99 no)
      if (a.length === 2) {
        const mTok = mdToken(b, 'M')
        const dTok = mdToken(c, 'd')
        return `yy-${mTok}-${dTok}`
      }
    }
  }

  // 3) Numéricos con separador '/'
  if (raw.includes('/')) {
    const [a, b, c] = raw.split('/')
    if (a && b && c && /^\d+$/.test(a + b + c)) {
      const na = parseInt(a, 10)
      const nb = parseInt(b, 10)
      const nc = parseInt(c, 10)

      const aIsYear = a.length === 4 || na > 31
      const bIsYear = b.length === 4 || nb > 31
      const cIsYear = c.length === 4 || nc > 31

      if (aIsYear) {
        const mTok = mdToken(b, 'M')
        const dTok = mdToken(c, 'd')
        return `${yearToken(a)}/${mTok}/${dTok}`
      }
      if (cIsYear) {
        let firstIsDay
        if (na > 12) firstIsDay = true
        else if (nb > 12) firstIsDay = false
        else firstIsDay = true // convención dd/MM/yyyy

        const firstTok = mdToken(a, firstIsDay ? 'd' : 'M')
        const secondTok = mdToken(b, firstIsDay ? 'M' : 'd')
        return `${firstTok}/${secondTok}/${yearToken(c)}`
      }
      if (bIsYear) {
        const firstIsMonth = na <= 12
        const firstTok = mdToken(a, firstIsMonth ? 'M' : 'd')
        const lastTok = mdToken(c, firstIsMonth ? 'd' : 'M')
        return `${firstTok}/${yearToken(b)}/${lastTok}`
      }

      if (a.length === 2 && c.length === 2) {
        // dd/MM/yy
        const firstTok = mdToken(a, 'd')
        const secondTok = mdToken(b, 'M')
        return `${firstTok}/${secondTok}/yy`
      }
    }
  }

  // 4) ISO simple yyyy-MM-dd (sin pensar tiempos)
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return 'yyyy-MM-dd'

  return null
}

/**
 * @author Pedro Antonio
 * @function parseDate
 * @description Parsea flexiblemente una fecha recibida como `Date` nativo, timestamp numérico o string en múltiples formatos.
 * Detecta el patrón compatible Luxon (usando `detectLuxonFormat`) y hace fallback a ISO/RFC/SQL y finalmente a `new Date()`.
 * Por defecto retorna un objeto `DateTime` válido; si `returnAsJsDate` es true retorna un `Date` de JS.
 * Retorna `null` si no es posible obtener una fecha válida.
 * @param {Object} params
 * @param {string|Date|number} params.dateStr - Valor de fecha (string, Date o timestamp). Alias legacy del nombre.
 * @param {string|Date|number} [params.value] - Alternativo a `dateStr`; si se provee tiene prioridad.
 * @param {string} [params.toFormat='dd/MM/yyyy'] - Formato de salida cuando se retorna `DateTime`.
 * @param {string} [params.locale='es'] - Locale para parsing y formateo.
 * @param {boolean} [params.returnAsJsDate=false] - Si true retorna `Date` en lugar de `DateTime`.
 * @param {boolean} [params.strict=false] - Si true evita fallback a `new Date()` genérico.
 * @returns {import('luxon').DateTime|Date|null} Fecha parseada o null si inválida.
 * @example
 * // String con guiones ambiguo
 * parseDate({ dateStr: '2025-12-1' }) // DateTime (yyyy-M-d)
 * @example
 * // ISO completo
 * parseDate({ dateStr: '2025-12-01T10:30:00Z', returnAsJsDate: true }) // Date
 * @example
 * // Texto en español
 * parseDate({ dateStr: '28 de junio del 2023', toFormat: "d 'de' LLLL 'del' yyyy" })
 */
const parseDate = ({
  date,
  toFormat = 'dd/MMM/yyyy',
  locale = 'es',
  returnAsJsDate = false,
  strict = false
} = {}) => {
  const input = date
  if (!input) return null

  // 1) Date nativo
  if (date instanceof Date) {
    if (isNaN(date)) return null
    const dtFromJs = DateTime.fromJSDate(date).setLocale(locale)
    return returnAsJsDate ? dtFromJs.toJSDate() : dtFromJs
  }

  // 2) Timestamp numérico
  if (typeof input === 'number') {
    const dtFromMillis = DateTime.fromMillis(input).setLocale(locale)
    if (!dtFromMillis.isValid) return null
    return returnAsJsDate ? dtFromMillis.toJSDate() : dtFromMillis
  }

  // 3) String
  if (typeof input === 'string') {
    const raw = input.trim()
    if (!raw) return null

    // Intentar detección personalizada
    const detected = detectLuxonFormat(raw)
    let dt
    if (detected) {
      dt = DateTime.fromFormat(raw, detected, { locale })
      if (!dt.isValid) dt = null
    }

    // Fallbacks ISO/RFC/SQL
    if (!dt) {
      dt = DateTime.fromISO(raw, { locale })
      if (!dt.isValid) dt = DateTime.fromRFC2822(raw, { locale })
      if (!dt.isValid) dt = DateTime.fromSQL(raw, { locale })
      if (!dt.isValid) dt = null
    }

    // Último intento: constructor nativo (solo si no strict)
    if (!dt && !strict) {
      const native = new Date(raw)
      if (!isNaN(native)) {
        dt = DateTime.fromJSDate(native).setLocale(locale)
      }
    }

    if (!dt || !dt.isValid) return null

    // Formateo de salida si se retorna DateTime
    if (!returnAsJsDate) {
      // Si se detectó un formato específico y el usuario pide uno distinto, re-formatear
      try {
        return dt.setLocale(locale).toFormat(toFormat)
      } catch (_) {
        return dt
      }
    }
    return dt.toJSDate()
  }

  return null
}

export { dateDayMonthCompleteAndYearComplete, limitExpirationDateInContract, dateInDialogChanceDate, convertDateBDToShow, convertStringInDates, convertToStandarDate, parseCustomDate, normalizeDateForSorting, detectLuxonFormat, parseDate }